import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'Ample - (BSC)',
  description: 'Earn AMPLE  through yield farming ',
  image: 'https://ampleswap.com/images/swapimg/twitter.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('AmpleDex')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('AmpleDex')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('AmpleDex')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('AmpleDex')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('AmpleDex')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('AmpleDex')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('AmpleDex')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('AmpleDex')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('AmpleDex')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('AmpleDex')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('AmpleDex')}`,
      }
    default:
      return null
  }
}
